import React, { useState } from 'react';

// Sello de Flow: el logo "flow" en verde lima sobre verde oliva, su combinación oficial, recortado de la
// portada del "Manual Botón de Pago" que Flow entrega a sus clientes (manual-botondepago-flowpagos.pdf).
// No es un kit de marca: ese manual no trae reglas de uso del logo (riesgo aceptado por Agustín el
// 2026-09-30). No se dibuja ni se imita: si el archivo falta no se muestra nada.
const SelloFlow = ({ alto = 32 }) => {
  const [roto, setRoto] = useState(false);
  if (roto) return null;
  return (
    <img
      src="/flow-sello.png"
      alt="Flow"
      height={alto}
      style={{ height: alto, width: 'auto', display: 'block' }}
      onError={() => setRoto(true)}
    />
  );
};

export default SelloFlow;
